import { render } from "./StorageBuilder.vue?vue&type=template&id=1ed1be2f"
import script from "./StorageBuilder.vue?vue&type=script&lang=js"
export * from "./StorageBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__